export const MARK_AS_TOUCH_DEVICE = 'MARK_AS_TOUCH_DEVICE';
